import { message, Modal } from "antd"

import http from 'auth/FetchInterceptor'
import CategoryListData from 'assets/data/category-list.data.json'
import { IMAGE_BASE_URL } from "configs/AppConfig"



export const getAllData = ({ url }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const  data  = await http.get(url)
            resolve(data)
        } catch (error) {
            reject(error)
        }
    })

}

export const getDataById = ({ url = "", id }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.get(`${url}/${id}`)
            // if (resp.success) {
            //     message.success(`${resp.message} added successfully`);
            // } else {
            //     message.success(`Error`);
            // }
            resolve(resp)
        } catch (error) {
            console.log(error)
            reject(error)
        }
    })
    // http.get('')
}

export const createData = ({ url, data }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.post(url, data)
            if (resp.success) {
                message.success(`${resp.message} added successfully`);
            } else {
                message.success(`Error`);
                reject('e')
            }
            resolve(resp)
        } catch (error) {
            console.log(error)
            reject(error)
        }
    })


}
export const createDataa = ({ url, data }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.post(url, data)
            if (resp.success) {
               
            } else {
                
                reject('e')
            }
            resolve(resp)
        } catch (error) {
            console.log(error)
            reject(error)
        }
    })


}

export const createDataUpdata = ({ url, id }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.post(`${url}/${id}`)
            if (resp.success) {
                resolve(true)
                message.success(`${resp.message} successfully`);
            } else {
                message.success(`Error`);
            }

        } catch (error) {

            reject(error)
        }
    })
}
export const updateData = ({ url, data, id }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.patch(`${url}/${id}`, data)
            console.log(data)
            console.log(resp)
            if (resp.success) {
                message.success(`${resp.message} Updated successfully`);
            } else {
                message.success(`Error`);
            }
            resolve(resp)
        } catch (error) {
            reject(error)
        }
    })

}
export const putData = ({ url, data, id='' }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await http.put(`${url}${id ? '/' + id : ''}`, data)
            if (resp.success) {
                message.success(`${resp.message} Updated successfully`);
            } else {
                message.success(`Error`);
            }
            resolve(resp)
        } catch (error) {
            reject(error)
        }
    })

}



export const deleteData = ({ url = "", id }) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: 'Are you sure?',
            content: 'Are you sure want to delete this item?',
            onOk: async () => {
                try {
                    const resp = await http.delete(`${url}/${id}`)
                    if (resp.success) {
                        resolve(true)
                        message.success(`${resp.message} successfully`);
                    } else {
                        message.success(`Error`);
                    }

                } catch (error) {

                    reject(error)
                }
            }
        })
    })

}
export const deletePostData = ({ url = "", id }) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: 'Are you sure?',
            content: 'Are you sure want to delete this item?',
            onOk: async () => {
                try {
                    const resp = await http.post(`${url}/${id}`)
                    if (resp.success) {
                        resolve(true)
                        message.success(`${resp.message} successfully`);
                    } else {
                        message.success(`Error`);
                    }

                } catch (error) {

                    reject(error)
                }
            }
        })
    })

}




export const updateProductAvailability = ({ url = "", availability, id }) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            cancelText:'No',
            okText:'Yes',
            title: 'Are you sure?',
            content: `Are you sure want ${availability === 'in-stock' ? 'Mark to Out of Stock' : 'Mark to Product Available'} this item?`,
            onOk: async () => {
                try {
                    const resp = await http.patch(`${url}/${id}?availability=${availability === 'in-stock' ? 'out-of-stock' : 'in-stock'}`)
                    if (resp.success) {
                        resolve(true)
                        message.success(`${resp.message} status updated successfully`);
                    } else {
                        message.success(`Error`);
                    }

                } catch (error) {

                    reject(error)
                }
            }
        })
    })

}



















export const updateStatusById = ({ url = "", status, id }) => {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: 'Are you sure?',
            content: `Are you sure want to ${status === 'hold' ? 'activate' : 'hold'} this item?`,
            onOk: async () => {
                try {
                    const resp = await http.patch(`${url}/${id}?status=${status === 'hold' ? 'active' : 'hold'}`)
                    if (resp.success) {
                        resolve(true)
                        message.success(`${resp.message} status updated successfully`);
                    } else {
                        message.success(`Error`);
                    }

                } catch (error) {

                    reject(error)
                }
            }
        })
    })

}


export const ImageUrlFun = (val)=>{
	if (val) {
		return `${val}`
	}else{
		return '/img/img-placeholder.svg'
	}
}

export const priceFormat = (val)=>{
    return `₹${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}/-`
}



    // Modal.confirm({
    //     title: 'Are you sure?',
    //     content: 'Are you sure want to delete this item?',
    //     onOk: () => {
    //         message.success(`Record deleted successfully`);
    //     }
    // })
    // http.get('')
// }




